/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 *
 *  @author estelle.giuly
 *
 */
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {SkeletonElementsModule} from 'skeleton-elements/angular';

import {ConfigurationModule} from '../../+configuration/configuration.module';
import {RegulationTreeService} from '../../+configuration/regulation-tree/regulation-tree.service';
import {ApiModule} from '../api/api.module';
import {EmployeeFormModule} from '../employee-form/employee-form.module';
import {EmployeesListModule} from '../employees-list/employees-list.module';
import {EmployeesMenuModule} from '../employees-menu/employees-menu.module';
import {EmployeesSharedModule} from '../employees/employees-shared.module';
import {FormGeneratorModule} from '../form-generator/form-generator.module';
import {ModalModule} from '../modal/modal.module';
import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';
import {UserModule} from '../user/user.module';
import {WorkflowV2Module} from '../workflow/workflow-v2.module';

import {HireAdditionalInformationComponent} from './hire-additional-information/hire-additional-information.component';
import {HireEmployeeModelComponent} from './hire-employee-model/hire-employee-model.component';
import {HireEmployeeComponent} from './hire-employee/hire-employee.component';
import {HireOptionsCopyComponent} from './hire-options-copy/hire-options-copy.component';
import {HireUtilsService} from './hire-utils.service';
import {HireService} from './hire.service';

@NgModule({
  imports: [
    ApiModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    UiModule,
    EmployeesSharedModule,
    EmployeesListModule,
    TabsModule,
    ModalModule,
    PipesModule,
    UserModule,
    EmployeesMenuModule,
    FormGeneratorModule,
    ConfigurationModule,
    WorkflowV2Module,
    EmployeeFormModule,
    SkeletonElementsModule,
    RouterModule
  ],
  declarations: [
    HireEmployeeComponent,
    HireAdditionalInformationComponent,
    HireEmployeeModelComponent,
    HireOptionsCopyComponent
  ],
  exports: [
    HireEmployeeComponent,
    HireAdditionalInformationComponent,
    HireEmployeeModelComponent,
    HireOptionsCopyComponent
  ],
  providers: [
    HireService,
    HireUtilsService,
    RegulationTreeService
  ]
})

export class HireModule {
}
